import type { PublicRoute } from "../../../routes/registry";
import EnquireConfirmationPage from "../EnquireConfirmationPage";

/**
 * Enquiry received (Story #25446). Registering a module replaces the pre-registry "existing"
 * /enquire/confirmation entry, so the restyled page renders full-bleed (its own .gw-done frame) instead
 * of inside LegacyFrame. Title and description are unchanged from that entry (BR-WEB-004). It stays out
 * of sitemap.xml: a post-submit page, not a landing page (#25447).
 */
const route: PublicRoute = {
  path: "/enquire/confirmation",
  element: <EnquireConfirmationPage />,
  title: "Thanks — we've received your enquiry | Greatway Patios",
  description: "A local rep will review your enquiry and get back to you within two business days.",
};

export default route;
